/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/auth/Login.vue'
// Routes
import Dashboard from "../views/Dashboard";
import UserProfile from "../views/UserProfile";
import TableList from "../views/TableList";
import Typography from "../views/Typography";
import Icons from "../views/Icons";
import Maps from "../views/Maps";
// import Notifications from "../views/Notifications";
import Users from "../pages/users/Users";
import Cities from "../pages/cities/Cities";
import Sliders from "../pages/sliders/Sliders";
import Categories from "../pages/categories/Categories";
import Countries from "../pages/countries/Countries";
import Campaigns from "../pages/campaigns/Campaigns";
import Products from "../pages/products/Products";
import Partners from "../pages/partners/Partners";
import Stores from "../pages/stores/Stores";
import Notifications from "../pages/notifications/Notifications";
import CustomerService from "../pages/CustomerService/CustomerService";
Vue.use(Router)

function routes() {
  let routes = [
    {path: '*', name: 'dash', redirect: '/dashboard', meta: {forAuth: true}},
    {path: '/user-profile', name: 'User', component: UserProfile, meta: {forAuth: true}},
    {path: '/login', name: 'Login', component: Login, meta: {forVisitors: true}},
    {path: '/', name: 'Dashboard', component: Dashboard, meta: {forAuth: true}},
    {path: '/table-list', name: 'Table List', component: TableList, meta: {forAuth: true}},
    {path: '/typography', name: 'Typography', component: Typography, meta: {forAuth: true}},
    {path: '/icons', name: 'Icons', component: Icons, meta: {forAuth: true}},
    {path: '/maps', name: 'Maps', component: Maps, meta: {forAuth: true}},
    {path: '/notifications', name: 'Notifications', component: Notifications, meta: {forAuth: true}},
    {path: '/users', name: 'Korisnici', component: Users, meta: {forAuth: true}},
    {path: '/cities', name: 'Gradovi', component: Cities, meta: {forAuth: true}},
    {path: '/sliders', name: 'Slajderi', component: Sliders, meta: {forAuth: true}},
    {path: '/categories', name: 'Kategorije', component: Categories, meta: {forAuth: true}},
    {path: '/countries', name: 'Drzave', component: Countries, meta: {forAuth: true}},
    {path: '/campaigns', name: 'Kampanje', component: Campaigns, meta: {forAuth: true}},
    {path: '/products', name: 'Proizvodi', component: Products, meta: {forAuth: true}},
    {path: '/partners', name: 'Partneri', component: Partners, meta: {forAuth: true}},
    {path: '/customerService', name: 'Podrska', component: CustomerService, meta: {forAuth: true}},
    {path: '/stores', name: 'Prodavnice', component: Stores, meta: {forAuth: true}},
    {path: '/notifications', name: 'Notifikacije', component: Notifications, meta: {forAuth: true}},
  ]
  return routes
}

export default new Router({
  mode: 'history',
  routes: routes()
});

// Vue.use(Meta)
//
// // Bootstrap Analytics
// // Set in .env
// // https://github.com/MatteoGabriele/vue-analytics
// if (process.env.GOOGLE_ANALYTICS) {
//     Vue.use(VueAnalytics, {
//         id: process.env.GOOGLE_ANALYTICS,
//         router,
//         autoTracking: {
//             page: process.env.NODE_ENV != 'development'
//         }
//     })
// }

// export default router
